/**
 * CTA Text Block animation
 */
export default function () {
    const blocks = document.querySelectorAll('.cta-text-block');
    if (blocks.length === 0) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: isMobile ? 0.6 : 0.6,
        },
    );

    blocks.forEach((block) => observer.observe(block));
}